import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, } from '@angular/common/http'
import { HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppLayoutModule } from './layout/app.layout.module';
import { UserCookiePipe } from 'src/app/pipe/user-cookie-pipe'
import { AuthInterceptor } from './auth/auth.interceptor'
import { CommonModule } from '@angular/common'
import { ErrorInterceptor } from './auth/error.interceptor'
import { MessageService,ConfirmationService } from 'primeng/api'
import { NgxSpinnerModule } from "ngx-spinner";
import { MiscMasterComponent } from './page/common/misc-master/misc-master.component'
import { ConfirmDialogModule } from 'primeng/confirmdialog'
import { ToastModule } from 'primeng/toast'
import { ProgressSpinnerModule } from 'primeng/progressspinner';
@NgModule({
    declarations: [
        AppComponent,
        MiscMasterComponent
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        ConfirmDialogModule,
        ToastModule,
        CommonModule,
        ProgressSpinnerModule,
        NgxSpinnerModule
    ],
    providers: [
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
         UserCookiePipe, MessageService,
        ConfirmationService, DatePipe,MiscMasterComponent
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
